module.exports = __webpack_public_path__ + "media/images/logos/University-of-Toronto-Trinity-College-f8cb085b6612939a43aae5cba0f289b4.svg";